import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Home from './components/Home';
import ReportDetail from './components/ReportDetail';
import ReportList from './components/ReportList';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import './App.css';

// Component to handle SEO redirects
function RedirectHandler() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Check if there's a redirect parameter
    const redirectPath = searchParams.get('redirect');
    if (redirectPath) {
      // Remove the redirect parameter and navigate to the target path
      navigate(redirectPath, { replace: true });
    }
  }, [navigate, searchParams]);

  return null;
}

// Component to scroll to top on route change
function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return null;
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <RedirectHandler />
          <ScrollToTop />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/reports" element={<ReportList />} />
            <Route path="/report/:id" element={<ReportDetail />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App; 